const authModule = require('firebase').auth;

export default authModule;
